// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"7381d569","298":"a2989f02","372":"5e4aa018","615":"a2989f02","650":"9445e5a3","735":"79e0066e","750":"a2989f02","937":"a2989f02"}[chunkId] + ".chunk.css";
};